<template>
  <BaseModule
    @click="click"
    @more="more"
    :index="index"
    :data="data"
    :isEditMode="isEditMode"
    :hideEditButton="hideEditButton"
    class="module-list"
  >
    <div class="list-module-body">
      <div v-for="(row, i) in data.value" :key="i">
        <SubTag v-if="row.type==='tag'" :data="row" :config="config"></SubTag>
        <SubRange v-if="row.type==='range'" :data="row">{{row}}</SubRange>
        <SubMedia v-if="row.type==='media'" :data="row">{{row}}</SubMedia>
        <SubLine v-if="row.type==='line'" :data="row">{{row}}</SubLine>
        <SubQa v-if="row.type==='qa'" :data="row">{{row}}</SubQa>
      </div>
    </div>
  </BaseModule>
</template>

<script>
import BaseModule from './BaseModule.vue'
import {
  Line as SubLine,
  Media as SubMedia,
  Qa as SubQa,
  Range as SubRange,
  Tag as SubTag
} from './sub'

export default {
  components: {
    BaseModule,
    SubTag,
    SubRange,
    SubMedia,
    SubLine,
    SubQa
  },
  props: {
    hideEditButton: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    config: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click () { this.$emit('click') },
    more () { this.$emit('more') }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.list-module-body {
  padding-top: 12px;
  font-size: var(--textSize3);
  @media (--mediaPc) {
    padding: 12px 0;
  }
  @media (--mediaPc) {
    padding-top: calc(12px / var(--scale));
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/ListModule.vue